import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

export const REMINDER_PATH = 'calendarItem'

export function createOrUpdatePharmacy(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${REMINDER_PATH}/createOrUpdate`, data, {
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function getListCalendarItems(userId, filterRequest) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${REMINDER_PATH}/getList`, filterRequest, {
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function getRecipientsOptions(userId) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${REMINDER_PATH}/getRecipientsOptions`, {
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function getAppointmentList(userId, hospitalId, type) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${REMINDER_PATH}/getAppointmentList`, {
            params: {userId, hospitalId, type},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function updateCalendarItemStatus(data, userId) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${REMINDER_PATH}/updateStatus`, data, {
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

//#region Delete
export function deleteReminder(userId, id) {
    return axiosInstance
        .delete(`${BACKEND_ENDPOINT}/${REMINDER_PATH}/deleteById`, {
            params: {userId, id},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion
